const Or: React.FC = () => {
  return (
    <div className="py-3 text-black font-bold text-sm w-full text-center relative">
      <span className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-[2px] bg-gray-200" />
      <span className="bg-white relative px-5">OR</span>
    </div>
  )
}

export default Or
